import React, { useEffect } from "react";
import { Grid, IconButton, Icon, AppBar, Toolbar, Button } from "@material-ui/core";
import { Formik } from "formik";
import DefaultButton from "components/items/default-button";

const FilterFormContent = ({
  formikProps,
  onClose,
  onReset,
  showHeader,
  filters,
  renderActions,
}) => {
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key !== "Enter") return;
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return;
      e.preventDefault();
      // Ensure any pending single-date selections (DateRange components) are committed before submit
      if (window.dateRangeCommitters) {
        window.dateRangeCommitters.forEach(fn => {
          try { fn(); } catch (err) { /* swallow */ }
        });
      }
      formikProps.handleSubmit();
      onClose();
    };
    window.addEventListener("keydown", handleKeyDown, true);
    return () => window.removeEventListener("keydown", handleKeyDown, true);
  }, [formikProps, onClose]);

  return (
    <>
      {showHeader && (
        <AppBar className="relative">
          <Toolbar>
            <Grid container justify="space-between" alignItems="center">
              <IconButton edge="start" color="inherit" onClick={() => onClose()}><Icon>clear</Icon></IconButton>
              <div>
                {onReset && <Button color="inherit" onClick={() => { onReset(); onClose(); }}>Clear</Button>}
                <Button type="button" color="inherit" className="ml-8" onClick={() => { formikProps.handleSubmit(); onClose(); }}>Apply</Button>
              </div>
            </Grid>
          </Toolbar>
        </AppBar>
      )}
      <div className="pt-24 overflow-y-auto flex flex-col flex-1 justify-between">
        {filters && filters(formikProps)}
        <div className="mt-16 py-16 flex justify-center">
          {renderActions ? renderActions({ onReset, onClose, ...formikProps }) : (
            <DefaultButton
              type="button"
              variant="outlined"
              className="w-320"
              onClick={() => { formikProps.handleSubmit(); onClose(); }}
              label="Apply"
              size="medium"
            />
          )}
        </div>
      </div>
    </>
  );
};

const FilterForm = ({
  initialValues,
  filters,
  onSubmit,
  onClose,
  onReset,
  showHeader = true,
  renderActions,
}) => (
  <Formik
    initialValues={initialValues}
    onSubmit={onSubmit}
  >
    {formikProps => (
      <FilterFormContent
        formikProps={formikProps}
        onClose={onClose}
        onReset={onReset}
        showHeader={showHeader}
        filters={filters}
        renderActions={renderActions}
      />
    )}
  </Formik>
);

export default FilterForm;
